module.exports = __webpack_public_path__ + "static/media/bowl-breakfast-egg-svgrepo-com.bceafa3e.svg";